import { computed } from 'vue'

import useFeature from '@/composables/useFeature'
import featureNames from '@/lib/featureNames'

/**
 * Onboarding-local feature flags. Wraps `useFeature()` so leaf components do not
 * re-implement `inject('features')` with ad-hoc types.
 */
export function useOnboardingFeatures() {
  const { isFeatureActive, getFeature } = useFeature()

  const isAssistedOnboardingEnabled = computed(() =>
    isFeatureActive(featureNames.ASSISTED_ONBOARDING)
  )
  /** Website scrape + progress bar. Requires catalog slug `onboarding-web-scraping`. */
  const isOnboardingWebScrapingEnabled = computed(() =>
    isFeatureActive(featureNames.ONBOARDING_WEB_SCRAPING)
  )
  const isCommissionEditable = computed(() =>
    Boolean(getFeature(featureNames.COMPANY)?.config?.isCommissionEditable)
  )
  const isLogoEditable = computed(() =>
    Boolean(getFeature(featureNames.COMPANY)?.config?.isLogoEditable)
  )

  return {
    isFeatureActive,
    getFeature,
    isAssistedOnboardingEnabled,
    isOnboardingWebScrapingEnabled,
    isCommissionEditable,
    isLogoEditable,
  }
}
